import React from 'react';
import moment from 'moment';
import { Page } from '../../../../../../../../components/Print/Print';
import './MarshCover.scss';

const MarshCover = ({ theme, insuredBusinessName, industryName, date, dateFormat }) => {
  return (
    <Page>
      <div className="marsh-report-preview-cover" style={{ fontFamily: theme.body?.font }}>
        <div className="marsh-report-preview-cover-header">
          <div className="company-logo" />
          <div className="header-details">
            <div className="date-issued">{`Date issued ${moment(date).format(dateFormat)}`}</div>
            <div className="insured-business-name">{insuredBusinessName}</div>
          </div>
        </div>
        <div className="marsh-report-preview-cover-title">
          <h1
            className="marsh-report-title"
            style={{ fontFamily: theme.headings?.h1?.font, fontWeight: theme.headings?.h1?.weight }}
          >
            Insurance risk report
          </h1>
          <h2 className="marsh-report-subtitle" style={{ fontFamily: theme.body?.font }}>
            {industryName}
          </h2>
        </div>
        <div className="marsh-report-preview-cover-image" />
      </div>
    </Page>
  );
};

export default MarshCover;
